import { SmartComponent } from "smart-component-js";

class ArticleIndexComponent extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.element = element;
    this.description = this.element.querySelector(".article-recipe-details__article-content");
    this.indexesWrapper = this.element.querySelector(".article-recipe-details__indexes");
    this.isOpen = false;
    this.init();
  }

  createArticleIndex(titles) {
    this.indexesWrapper.innerHTML = `
        <div class="article-index">
            <h2 class="article-index__title">Indice dell'articolo</h2>
            <ul class="article-index__list">${this.getIndexList(titles)}</ul>
        </div>
    `;
  }

  getIndexList(list) {
    let html = '';
    list.forEach((el) => {
      const label = el.innerText;
      html += `
        <li class="article-index__item">
            <a href="#${label.replaceAll(' ', '-')}" class="article-index__link">
                <span class="article-index__icon">
                    <icontemplate icon="arrow" size="small" clazz="icon danger"></icontemplate>
                </span>
                ${label}
            </a>
        </li>
      `;
    });
    return html;
  }


  setAnchors(titles) {
    titles.forEach((el) => {
      el.id = el.innerText.replaceAll(' ', '-');
    });
  }

  init() {
    if(!this.description) return;
    const titles = this.description.querySelectorAll('h3');
    if(titles.length < 2) return;
    this.createArticleIndex(titles);
    this.setAnchors(titles);
  }
}

export default ArticleIndexComponent;
